import type { AgentRow, FleetIdentityRow } from '../transport/api'

/**
 * The identity list the Clean View resolves senders against: local roster rows
 * first (their naming wins, and the local machine's name comes from config),
 * then every OTHER machine's agents from the account fleet, carrying their
 * machine as `device_name` — the field machineNameOf prefers.
 *
 * This union is the missing half of describeHash's design: it was written
 * "FLEET FIRST" against a `fleet` prop that only ever received /agent/all —
 * local rows — so a cross-machine sender (the common case for agent messages)
 * could never resolve and rendered as its bare hash.
 */
export function fleetForIdentity(
  local: AgentRow[],
  cloud: FleetIdentityRow[] | undefined,
): Array<{ session: string; hash?: string; device_name?: string; host?: string | null }> {
  const out: Array<{ session: string; hash?: string; device_name?: string; host?: string | null }> =
    [...local]
  const seen = new Set(local.map((a) => a.hash?.toLowerCase()).filter(Boolean))
  for (const r of cloud ?? []) {
    const h = r.hash.toLowerCase()
    if (seen.has(h)) continue
    seen.add(h)
    out.push({ session: r.session, hash: h, host: null, device_name: r.machine })
  }
  return out
}
